import {
	ApiClientFactory
} from '../ApiClientFactory';

import {
	API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const GroupsClient = {
	/**
	 *
	 * Returns group
	 */
	getGroupUsers(groupId) {
		return clientFactory.get(API_URL + 'groups/' + groupId + '/users');
	}


};